import React, { Component } from 'react'
import shortid from "shortid";
import MyComponent from '../components/MyComponent';
export class CssPage extends Component {
    render() {
        var state = this.props.state;
        var contentId = state.contentId
        return (
        <>

        <div className="containerWarp" data-cont-id={contentId?contentId:""} data-zone="CssContent" >
             <div className="primary-zone" data-zone="CssContent" >
                <div className={"row m-0 " + state.attributes.class ? state.attributes.class : ""} data-page-id={contentId?contentId:""} id={state.attributes.id} data-id="zone" data-zone="CssContent" >
                    {/* added new class for vastproSite padding issue (vastpro-p-0) */}
                    <div className="content row container-fluid justify-content-around gx-0 vastpro-p-0" data-page-id={contentId?contentId:""} data-id="zone" data-zone="CssContent">
                        {/* <NavbarHeader/>                    */}    
                        {state.contents.CssContent.map(content => {
                            let cssContentType = content['@type'];
                           return (
                            <MyComponent type={cssContentType} key={shortid.generate()} containerObject={content} contentId={contentId} dataZone="CssContent"  templateName={cssContentType}/>  
                               )
                        }
                        )}
                    </div>
                </div>
            </div>
        </div>

        </>
        )
    }
}

export default (CssPage);